module.exports = __webpack_public_path__ + "img/lg_ring_g_s_0_1@3x.3f0ea270.png";